import React from 'react'

import { i18n } from '@localization'
import { useToast } from '@zet/common/components/toast'
import { Button } from '@zet/design-system/button'
import { Stack } from '@zet/design-system/layout'
import { H3, H5 } from '@zet/design-system/typography'
import Certificate from '@zet/svg/certificate'

import { CerificateImage } from '@screens/trainings/components/cerificateImage'
import { useDownloadAndShare } from '@zet/common/hooks/useDownloadAndShare'


const Success = ({
  submitQuizResponseData,
  certificateDescription1,
  certificateDescription2,
}) => {
  const toast = useToast()

  const onSuccess = () => {
    toast?.show({
      intent: 'success',
      heading: i18n.t('toastMessages.success'),
      description: i18n.t('toastMessages.downloadSuccessful'),
      hideAfter: 3000,
    })
  }

  const { ref, download } = useDownloadAndShare({
    width: 1258,
    height: 906,
    onSuccess: onSuccess,
  })

  return (
    <>
      <Stack className="mt-10 w-full self-center">
        <CerificateImage
          description1={certificateDescription1}
          description2={certificateDescription2}
          ref={ref}
        />
        {submitQuizResponseData ? (
          <Stack className="mb-4  mt-2 items-center self-center">
            <H3 className="text-white">{i18n.t('trainings.wellDone')}</H3>
            <H5 className="text-grays-50 text-center">
              {i18n.t('trainings.yourScore', {
                score: submitQuizResponseData?.data?.score,
              })}
            </H5>
          </Stack>
        ) : (
          <></>
        )}
      </Stack>
      <Stack className="absolute bottom-3 w-full px-3">
        <Button
          className="w-full"
          iconLeft={<Certificate className=" mt-1" />}
          onPress={download}
          eventName="click_action"
          eventPayload={{
            item_name: 'trainings_completed_take_quiz_download_certificate',
            score: submitQuizResponseData?.data?.score,
          }}
        >
          {i18n.t('trainings.downloadCer')}
        </Button>
      </Stack>
    </>
  )
}

export default Success
